import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import './processingOverlay.css';

function ProcessingOverlay({ show, message = 'Aguarde…', tagline = 'Sistema de Semáforos' }) {
  const [visible, setVisible] = useState(show);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (show) {
      setVisible(true);
      setClosing(false);
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = '';
      };
    }

    if (visible) {
      setClosing(true);
      const timer = setTimeout(() => {
        setVisible(false);
        setClosing(false);
        document.body.style.overflow = '';
      }, 160);
      return () => clearTimeout(timer);
    }

    return undefined;
  }, [show, visible]);

  if (!visible) return null;

  const backdropClass = closing
    ? 'ssat-processing-backdrop ssat-processing-backdrop--closing'
    : 'ssat-processing-backdrop';

  return ReactDOM.createPortal(
    <div className={backdropClass} role="status" aria-live="polite" aria-busy="true">
      <div className="ssat-processing-card">
        <div className="ssat-processing-accent" />
        <p className="ssat-processing-brand">SSAT</p>
        <p className="ssat-processing-tagline">{tagline}</p>

        <div className="ssat-processing-spinner-wrap" aria-hidden="true">
          <div className="ssat-processing-spinner-ring" />
          <div className="ssat-processing-spinner-core" />
        </div>

        {React.isValidElement(message) || (Array.isArray(message) && message.length) ? (
          <div className="ssat-processing-message">{message}</div>
        ) : typeof message === 'string' && message.includes('<') ? (
          <div className="ssat-processing-message" dangerouslySetInnerHTML={{ __html: message }} />
        ) : (
          <p className="ssat-processing-message">{message}</p>
        )}

        <div className="ssat-processing-bar-track">
          <div className="ssat-processing-bar-fill" />
        </div>
      </div>
    </div>,
    document.body,
  );
}

export default ProcessingOverlay;
